import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/comics';

const rankBadge = ['bg-secondary-500', 'bg-secondary-400', 'bg-secondary-300'];

export default function Ranking() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-trophy-line"></i> 热门排行
            </p>
            <h2 className="mt-1 font-display text-2xl text-foreground-900 md:text-3xl">本周人气 TOP 10</h2>
            <p className="mt-2 text-sm text-foreground-600">根据阅读量与收藏数据实时更新，看看大家都在追什么。</p>
          </div>
          <Link to="/comics?sort=hot" className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
          {hotComics.map((comic, i) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-transform duration-200 hover:-translate-y-0.5"
            >
              <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-sm font-bold text-background-50 ${rankBadge[i] ?? 'bg-foreground-300'}`}>
                {i + 1}
              </span>
              <div className="min-w-0 flex-1">
                <h4 className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-600">{comic.title}</h4>
                <p className="mt-0.5 flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-fire-fill text-primary-500"></i>
                  <span>{comic.rating}分</span>
                  <span className="text-foreground-300">·</span>
                  <span>{comic.category}</span>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}